module.exports = __webpack_public_path__ + "media/images/logos/angular-7d535e9caea7fc814c791168c51aeab3.svg";